import {environment} from "../../../environments/environment";
export const resolveUrl = (apiVersion: string, path: string): string => {  return `${environment.apiUrl}/${apiVersion}/${path}`}
